import React__default from 'react';

var DatamartLogo = function DatamartLogo(props) {
  var className = props.className,
    style = props.style;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    style: style,
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M3 22.3859V3.61408C3.00094 3.33173 3.07286 3.05454 3.2086 2.81C3.34435 2.56547 3.53922 2.36207 3.77388 2.22C4.00854 2.07792 4.27484 2.0021 4.54638 2.00004C4.81791 1.99799 5.08525 2.06978 5.32187 2.20829L21.215 11.598C21.4533 11.7387 21.6515 11.9426 21.7894 12.1889C21.9273 12.4351 22 12.715 22 13C22 13.285 21.9273 13.5649 21.7894 13.8111C21.6515 14.0574 21.4533 14.2613 21.215 14.402L5.32187 23.7917C5.08525 23.9302 4.81791 24.002 4.54638 24C4.27484 23.9979 4.00854 23.9221 3.77388 23.78C3.53922 23.6379 3.34435 23.4345 3.2086 23.19C3.07286 22.9455 3.00094 22.6683 3 22.3859V22.3859Z",
    fill: "#4871F0"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M33 13.6192V32.3863C32.999 32.6686 32.9271 32.9457 32.7914 33.1902C32.6556 33.4347 32.4607 33.638 32.2261 33.7801C31.9914 33.9221 31.7251 33.9979 31.4535 34C31.182 34.002 30.9146 33.9302 30.678 33.7918L14.784 24.4044C14.5458 24.2627 14.3479 24.058 14.2102 23.8113C14.0725 23.5645 14 23.2842 14 22.9989C14 22.7136 14.0725 22.4334 14.2102 22.1866C14.3479 21.9398 14.5458 21.7352 14.784 21.5935L30.678 12.2137C30.9143 12.0728 31.1821 11.9991 31.4545 12C31.7269 12.0009 31.9943 12.0764 32.2297 12.2189C32.4651 12.3614 32.6603 12.5658 32.7955 12.8117C32.9307 13.0575 33.0013 13.336 33 13.6192V13.6192Z",
    fill: "#4AEAEB"
  }));
};
DatamartLogo.defaultProps = {
  className: undefined,
  style: undefined
};
var DatamartLogo$1 = DatamartLogo;

export { DatamartLogo$1 as default };
